import React, { Component } from "react";
import { connect } from "react-redux";
import "./styles/index.scss";
import { Route, Switch } from "react-router-dom";
import BeforeCreateDeals from "../deals/dealsMenu/SelectDealTypePage";
import {
  PopupsConsumer,
  PopupsContext,
} from "../../helpers/contexts/popupsContext";

class SubHeader extends Component {
  render() {
    const { user, location } = this.props;

    if (!user || !user.role_id) {
      return null;
    }

    if (
      location.pathname &&
      location.pathname.indexOf("document-preview") > -1
    ) {
      return null;
    }

    const StyledRoute = ({ component: Component, classes, ...rest }) => {
      return (
        <Route
          {...rest}
          render={(routeProps) => (
            <div
              className={`sub-header-container ${classes} visible-${rest.state.subHeaderVisibility}`}
            >
              <Component {...routeProps} />
            </div>
          )}
        />
      );
    };

    return (
      <PopupsConsumer>
        {({ state }) => (
          <Switch>
            <StyledRoute
              exact
              path={`/:orgId/deals`}
              state={state}
              component={BeforeCreateDeals}
              classes={"deals deals-list"}
            />
            <StyledRoute
              exact
              path={`/:orgId/deals/before-create`}
              state={state}
              component={BeforeCreateDeals}
              classes={"deals new-deals"}
            />
            <StyledRoute
              path={`/:orgId/deals/:id`}
              state={state}
              component={BeforeCreateDeals}
              classes={"deals"}
            />
          </Switch>
        )}
      </PopupsConsumer>
    );
  }
}

const mapStateToProps = (state) => {
  const { user } = state.auth;
  return {
    user,
  };
};

SubHeader.contextType = PopupsContext;

export default connect(mapStateToProps)(SubHeader);
